import Drawer from 'react-modern-drawer';
import { Scrollbar } from 'react-scrollbars-custom';
import AgreementCrossIcon from 'shared/icons/agreement-cross-icon.svg';
import styles from './agreement-drawer.module.scss';

type AgreementDrawerProps = { open: boolean; onClose: () => void };
export const AgreementDrawer = ({ open, onClose }: AgreementDrawerProps) => {
  return (
    <Drawer className={styles.drawer} open={open} lockBackgroundScroll direction="bottom" onClose={onClose}>
      <div className={styles.drawerContent}>
        <div className={styles.agreement}>
          <Scrollbar style={{ width: '100%', height: '100%' }}>
            <div>Какой-то текст</div>
          </Scrollbar>
        </div>
        <div className={styles.drawerFooter}>
          <div className={styles.drawerClose} onClick={onClose}>
            Закрыть
            <img src={AgreementCrossIcon} alt="cross" width={16} height={16} />
          </div>
        </div>
      </div>
    </Drawer>
  );
};
